import { Input } from '../Input/Input';
import type { FormControlProps } from '../types';
import { useNumberInput } from './useNumberInput';

/**
 * This component is used to create a well-formatted (with comma auto-formatting) number input.
 * It uses the {@link useNumberInput} hook to create the input props.
 */
export const NumberInput = (props: NumberInputProps) => {
  const inputProps = useNumberInput(props);

  return <Input {...inputProps} type="number" />;
};

export type NumberInputProps = {
  /** Required prop to ensure the input is controlled */
  value: string;
  onChange: (value: string) => void;
  minIncrement?: string;
  defaultIncrement?: string;
  largeIncrement?: string;
  min?: string;
  max?: string;
  integerOnly?: boolean;
} & Omit<FormControlProps<HTMLInputElement>, 'onChange' | 'value' | 'type' | 'step' | 'security'>; // Instead of step, use minIncrement, defaultIncrement and largeIncrement
